import { Component, ElementRef, OnChanges, ViewChild, Input } from '@angular/core';
import { AdStatsUserActivityService } from '../../../../shared/services/ad-stats-user-activity.service';
import { OnboardingStageLabels } from '../../../../shared/domain/onboarding-stage.enum';

const Highcharts = require('highcharts/highcharts');

@Component({
  selector: 'cm-report-activity-by-stage-chart',
  template: `
    <div class="cm-card">
      <div class="cm-card-header">
	      <h3 class="cm-card-title">Stage</h3>
      </div>
      <div class="cm-card-content">
	      <div class="card-message" [hidden]="!loading">
		      <mat-spinner [color]="'primary'" [mode]="'indeterminate'" [diameter]="'30'"></mat-spinner>
	      </div>
	      <div class="card-message flex-column text-warning" [hidden]="loading || !noChartData">
		      <i class="fal fa-frown fa-2x mb-3" aria-hidden="true"></i>
		      <p>No data available for selected date range.</p>
	      </div>
				<div [hidden]="loading || noChartData" class="p-2">
		      <div #chart class="w-100"></div>
	      </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class ReportActivityByStageChartComponent implements OnChanges {
   @ViewChild('chart', {static: true}) chartEl: ElementRef;

  @Input()
  dateFrom: string;

  @Input()
  dateTo: string;

  loading = true;
  noChartData = true;

  constructor(private service: AdStatsUserActivityService) {
  }


  ngOnChanges() {
    this.loadChartData();
  }

  renderChart(xAxisData, seriesData) {
    const opts: any = {
      chart: {
        type: 'bar',
        height: 400,
      },
      title: {
        text: null
      },
      tooltip: {
        pointFormat: '<b>{point.y}</b>'
      },
      legend: {
        enabled: false
      },
      xAxis: {
        title: {
          text: 'Publisher'
        },
        categories: xAxisData,
        crosshair: true
      },
      yAxis: {
        title: {
          text: ''
        }
      },
      series: [{
        data: seriesData,
        dataLabels: {
          enabled: true,
          color: '#FFFFFF',
          x: -25,
        }
      }]
    };

    Highcharts.chart(this.chartEl.nativeElement, opts);
  }

  loadChartData() {
    this.loading = true;
    this.service.getActivityReportByStage(this.dateFrom, this.dateTo).subscribe(data => {
      const xAxisData = data.map(item => OnboardingStageLabels[item.stage]);
      const seriesData = data.map(item => item.count);

      this.loading = false;
      this.noChartData = xAxisData.length === 0;

      this.renderChart(xAxisData, seriesData);
    }, error => {
      this.loading = false;
    });
  }

}
